/**
 * Very simple cache implementation.
 */
export default class ClientCache {
    #cache = {}

    set(key, value) {
        this.#cache['#' + key] = value;
    }

    get(key) {
        return this.#cache['#' + key];
    }

    getAll() {
        return Object.values(this.#cache);
    }

    has(key) {
        return this.#cache['#' + key] !== undefined;
    }

    clear() {
        this.#cache = {};
    }
}
